import { useStore } from "@/store/store";
import { useCallback } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../ui/select";

type MapProjection = 'globe' | 'mercator';

interface ProjectionOption {
    value: MapProjection;
    label: string;
}

const PROJECTIONS: ProjectionOption[] = [
    { value: 'mercator', label: 'Flat' },
    { value: 'globe', label: 'Globe' },
];

export const ProjectionSelector = () => {
    const mapProjection = useStore(useCallback((state) => state.mapProjection, []));
    const setMapProjection = useStore(useCallback((state) => state.setMapProjection, []));

    const currentProjection = PROJECTIONS.find((proj) => proj.value === mapProjection);

    return (
        <Select
            value={currentProjection?.value}
            onValueChange={(value) => {
                setMapProjection(value as MapProjection);
            }}
        >
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Select projection" />
            </SelectTrigger>
            <SelectContent>
                {PROJECTIONS.map((projection) => (
                    <SelectItem key={projection.value} value={projection.value}>
                        {projection.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

